import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AutoLlamadas from "./pages/AutoLlamadas";
import _3Common from "./pages/3Common";
import LambertNemec from "./pages/LambertNemec";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import OutreachGenius from "./pages/OutreachGenius";
import NorsemenAuction from "./pages/NorsemenAuction";
import Espana from "./pages/Espana";
import Colombia from "./pages/Colombia";
import { InsuranceDemo } from "./pages/insurance/InsuranceDemo";
import { BishopAndQuerel } from "./pages/real-estate/BishopAndQuerel";
import {
  LifeInsuranceDEMO,
  MedicareInsuranceDEMO,
} from "./pages/insurance/insurance-demo";
import { MedicareInsuranceDEMOV2 } from "./pages/insurance/insurance-demo2";
import { MasterDEMO } from "./pages/insurance/master-demo";
import { TapetesSaoCarlos } from "./pages/brasil/tapetes-sao-carlos-demo";
import { AgentAutopilotDEMOEspanol } from "./pages/spain/agent-autopilot-demo-espanol";
import { BritishLifeDEMO } from "./pages/insurance/british-life-demo";
import { Postal3 } from "./pages/spain/postal-3";
import { BlossomBoost } from "./pages/brasil/regularizacaoFinanceira";
import { SigmadosDEMO } from "./pages/spain/sigmados-demo";
import { FinancialEstatePlannerDEMO } from "./pages/insurance/financial-estate-planner-demo"
import { WFSDemo } from "./pages/insurance/wfs";
import { IFWAnnuitiesDemo } from "./pages/insurance/ifw-annuities-demo";
import { CustomDemos } from "./pages/insurance/custom-demos";
import { AB360Demo } from "./pages/insurance/ab360-demo";
import { AgentAutopilotChatbot } from "./pages/insurance/agent-autopilot-chatbot";
import { InsuranceAgentTrainingDemo } from "./pages/insurance/insurance-agent-training-demo";
import { BorealBruin } from "./pages/BorealBruin";
import { TripemcoDemo } from "./pages/insurance/tripemco-demo";
import { ExpatInsureDemo } from "./pages/insurance/expatinsure-demo";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/auto-llamadas" element={<AutoLlamadas />} />
        <Route path="/3common" element={<_3Common />} />
        <Route path="/outreach-genius" element={<OutreachGenius />} />
        <Route path="/lambert-nemec" element={<LambertNemec />} />
        <Route path="/norsemen-auction" element={<NorsemenAuction />} />
        <Route path="/espana" element={<Espana />} />
        <Route path="/colombia" element={<Colombia />} />
        <Route path="/insurance-lead-magnet-demo" element={<InsuranceDemo />} />
        <Route path="/insurance" element={<MedicareInsuranceDEMO />} />
        <Route path="/bishop-querel" element={<BishopAndQuerel />} />
        <Route path="/tapetes-sao-carlos" element={<TapetesSaoCarlos />} />
        <Route
          path="/agent-autopilot-espanol"
          element={<AgentAutopilotDEMOEspanol />}
        />
        <Route path="/british-life" element={<BritishLifeDEMO />} />
        <Route path="/postal-3" element={<Postal3 />} />
        <Route path="/sigmados" element={<SigmadosDEMO />} />
        <Route path="/fin-estate-planner" element={<FinancialEstatePlannerDEMO />} />
        <Route path="/insurance-demo2" element={<MedicareInsuranceDEMOV2 />} />
        <Route path="/master-demo" element={<MasterDEMO />} />
        <Route path="/blossom-boost" element={<BlossomBoost />} />
        <Route path="/wfs" element={<WFSDemo />} />
        <Route path="/ifw" element={<IFWAnnuitiesDemo />} />
        <Route path="/custom-demos" element={<CustomDemos />} />
        <Route path="/ab360-demo" element={<AB360Demo />} />
        <Route path="/agent-autopilot-chatbot" element={<AgentAutopilotChatbot />} />
        <Route path="/insurance-agent-training-demo" element={<InsuranceAgentTrainingDemo />} />
        <Route path="/boreal-bruin" element={<BorealBruin />} />
        <Route path="/tripemco" element={<TripemcoDemo />} />
        <Route path="/expatinsure" element={<ExpatInsureDemo />} />
      </Routes>
    </Router>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
